import React from 'react';
import AppHeadline from 'components/Headline';

const Headline = () => {
    return <AppHeadline label="Organizing Committee" />;
};

export default Headline;
